<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="show"
      max-width="600"
      @input="v => v || closeDialog()"
    >
      <v-card>
        <v-card-title class="card-title">
          <span class="headline white--text text-uppercase">Create IpSigning Document</span>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container fluid>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                >
                  <v-text-field
                    v-model="strategyId"
                    type="text"
                    label="StrategyId"
                    :rules="requiredRule"
                    single-line
                    box
                    required
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>

          <v-alert
            v-if="createDocumentError"
            :value="true"
            type="error"
            class="my-3"
          >
            {{ createDocumentError }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="cancelAction()"
          >
            cancel
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            :disabled="processing"
            @click="createDocument()"
          >
            create
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'CreateIpSigningDocument',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    createDocumentError: {
      type: String,
      default: '',
    },
    processing: {
      type: Boolean,
      default: false,
    },
    submitAction: {
      type: Function,
      default: () => ({}),
    },
    cancelAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      valid: true,
      show: this.dialog,
      strategyId: null,
      requiredRule: [
        v => !!v || 'field is required',
      ],
    };
  },
  watch: {
    dialog(val) {
      this.show = val;
    },
    data(val) {
      this.strategyId = val.strategyId;
    },
  },
  methods: {
    async createDocument() {
      if (this.$refs.form.validate()) {
        this.submitAction(
          this.requestData(this.strategyId),
        );
      }
    },
    closeDialog() {
      this.cancelAction();
    },
    requestData(strategyId) {
      return {
        documentType: 'ip-signing',
        identifiers: {
          strategyId,
        },
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ire/CreateIpSigningDocument.vue